import TiptapEditor from '@/components/Editor/TiptapEditor';
import { commentEditorClasses } from '@/components/Editor/editorConfig';

export default function CommentRenderer({ content }) {
    return (
        <TiptapEditor
            content={content}
            editable={false}
            withBubbleMenu={false}
            withCodeBlocks
            withMentions
            customEditorClasses={commentEditorClasses}
        />
    );
} 